const selectHotspot = (e) => {
	let clickedHotspot = e.target.closest(".custom-hotspot");
	if (!clickedHotspot) return;

	const container = clickedHotspot.parentElement;
	const hotspots = container.querySelectorAll(".custom-hotspot");

	hotspots.forEach(hotspot => {
		if (hotspot === clickedHotspot) {
			hotspot.classList.toggle("custom-hotspot--selected");
		} else {
			hotspot.classList.remove("custom-hotspot--selected");
		}
	});
}

const closeHotspot = (e) => {
	const selectedHotspot = document.querySelector(".custom-hotspot--selected");
	if (selectedHotspot) {
		selectedHotspot.classList.remove("custom-hotspot--selected");
	}
}

(() => {
	const buttons = document.querySelectorAll(".custom-new-block");
	const closeButtons = document.querySelectorAll(".close-hotspot");

	buttons.forEach(button => {
		button.addEventListener("click", selectHotspot);
	});

	closeButtons.forEach(closeButton => {
		closeButton.addEventListener("click", closeHotspot);
	});
})();